<template>
  <div>
    <a-modal
      v-model:open="open"
      :title="$t('click.work')"
      centered
      @ok="handleOk"
      @cancel="handleClose"
      width="800px"
    >
      <a-form
        style="margin-top: 30px"
        :model="formState"
        layout="vertical"
        autocomplete="off"
        ref="formRef"
      >
        <a-row :gutter="[16, 12]">
          <a-col :span="12">
            <a-form-item
              :label="$t('click.order')"
              name="OrderNumber"
              :rules="[{ required: true, message: t('click.devicein') }]"
            >
              <a-select
                v-model:value="formState.OrderNumber"
                show-search
                :placeholder="$t('click.devicein')"
                :filter-option="filterOption"
                :options="options"
                @change="handleChange"
              ></a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :label="$t('click.phone')"
              name="Phone"
              :rules="[{ required: true, validator: checkPhone }]"
            >
              <a-input
                v-model:value="formState.Phone"
                :placeholder="$t('click.phonein')"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :label="$t('click.email')"
              name="Email"
              :rules="[{ required: true, validator: checkEmail }]"
            >
              <a-input
                v-model:value="formState.Email"
                :placeholder="$t('click.emailin')"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :label="$t('click.company')"
              name="Company"
              :rules="[{ required: true, message: t('click.companyin') }]"
            >
              <a-input
                v-model:value="formState.Company"
                :placeholder="$t('click.companyin')"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :label="$t('click.province')"
              name="Province"
              :rules="[{ required: true, message: t('click.provincein') }]"
            >
              <a-select
                v-model:value="formState.Province"
                :placeholder="$t('click.provincein')"
                :options="provinceList"
                @change="provinceChange"
              ></a-select>
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <a-form-item
              :label="$t('click.city')"
              name="City"
              :rules="[{ required: true, message: t('click.cityin') }]"
            >
              <a-select
                v-model:value="formState.City"
                :placeholder="$t('click.cityin')"
                :options="cityList"
                @change="cityChange"
                :disabled="cityDis"
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item
              :label="t('click.spareTitle')"
              name="sparePart"
              :rules="[{ required: true, message: t('click.spareContent') }]"
            >
              <a-select
                v-model:value="formState.sparePart"
                :placeholder="t('click.spareContent')"
                :options="spareList"
                @change="spareChange"
              ></a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12" v-if="Threshold === null">
            <a-form-item :label="$t('click.inventoryTitle')" name="inventory">
              <a-input
                v-model:value="inventory"
                type="number"
                :placeholder="$t('click.inventoryContent')"
              />
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item
              :label="$t('click.content')"
              name="Content"
              :rules="[{ required: true, message: t('click.contentin') }]"
              :labelCol="{ span: 4, offset: 24 }"
            >
              <a-textarea
                v-model:value="formState.Content"
                :placeholder="$t('click.contentin')"
                :auto-size="{ minRows: 3 }"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <template #footer>
        <a-button @click="handleCancel">{{ $t("click.notnow") }}</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleOk"
          :disabled="disabledVal"
          >{{ $t("click.submit") }}</a-button
        >
	  </template>
    </a-modal>

    <div class="header">
      <span class="back" @click="back">{{ $t("index.back") }}</span>
    </div>
    <div class="inner">
      <a-card :bordered="false" style="margin-bottom: 10px">
        <a-form
          ref="searchFormRef"
          name="advanced_search"
          class="ant-advanced-search-form"
          :model="searchFormState"
        >
          <a-row :gutter="24">
            <a-col :span="8">
              <a-form-item name="searchKey" :label="$t('click.event')">
                <a-input
                  v-model:value="searchFormState.searchKey"
                  :placeholder="$t('click.eventin')"
                />
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-button type="primary" @click="loadData()">
                {{ $t("click.search") }}
              </a-button>
              <a-button class="snowy-buttom-left" @click="reset">
                {{ $t("click.resert") }}
              </a-button>
            </a-col>
          </a-row>
        </a-form>
      </a-card>
      <a-card :bordered="false">
        <a-row :gutter="24">
          <a-col :span="12">
			  <!-- 填报工单 -->
            <a-button type="primary" @click="openModal()" style="margin-bottom: 25px">
              {{ $t("click.newevent") }}
            </a-button>
            <a-button type="primary" @click="openStock()" style="margin-left: 25px">{{
              $t("click.stock")
            }}</a-button>
          </a-col>
		  <a-col :span="5">
			<div>
				<a-form-item label="工单状态：" name="Group">
					<a-radio-group 
					v-model:value="groupValue" 
					button-style="solid"
					@change="groupChange"
				>
						<a-radio-button value="a">全部</a-radio-button>
						<a-radio-button value="b">待处理</a-radio-button>
						<a-radio-button value="c">已完成</a-radio-button>
					</a-radio-group>
				</a-form-item>
			</div>
		  </a-col>
          <a-col :span="7">
            <a-form-item label="快速查看：" name="Time">
              <a-radio-group
                v-model:value="timeValue"
                button-style="solid"
                @change="selectTime()"
              >
                <a-radio-button
                  v-for="time in timeList"
                  :key="time.key"
                  :value="time.key"
                >
                  {{ time.name }}</a-radio-button
                >
              </a-radio-group>
            </a-form-item>
          </a-col>
        </a-row>

        <a-table
          ref="table"
          :columns="columns"
          :dataSource="dataSource"
          bordered
          :row-key="(record) => record.id"
          :show-pagination="false"
          :tool-config="toolConfig"
          :loading="tbLoading"
          :pagination="pagination"
          @change="handleTableChange"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.dataIndex === 'eventStatus'">
              <a-tag v-if="record.eventStatus == t('click.status1')" color="blue">
                {{ $t("click.status1") }}
              </a-tag>
              <a-tag v-if="record.eventStatus == t('click.status2')" color="green">
                {{ $t("click.status2") }}
              </a-tag>
              <a-tag v-else color="orange"> {{ $t("click.status3") }} </a-tag>
            </template>
            <template v-if="column.dataIndex === 'action'">
              <a-space>
                <a @click="openForm(record)">{{ $t("click.look") }}</a>
              </a-space>
            </template>
          </template>
        </a-table>
      </a-card>

      <a-drawer
        v-model:open="Fopen"
        :title="$t('click.detail')"
        :width="1000"
        :destroy-on-close="true"
        @close="onFormClose"
      >
        <a-card
          :bordered="false"
          :loading="infoLoading"
          :title="$t('click.basic')"
          style="margin-bottom: 20px"
        >
          <a-descriptions bordered :column="2">
            <a-descriptions-item :label="$t('click.eventNum')">{{
              selectW.EventNum
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('click.ownOrder')">{{
              selectW.OrderNumber
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('click.ownUser')">{{
              selectW.UserName
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('click.ownCopany')">{{
              selectW.Company
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('click.phone')">{{
              selectW.Phone
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('click.ownTime')">{{
              selectW.CreateTime
            }}</a-descriptions-item>

            <a-descriptions-item :label="$t('click.ownEmail')">{{
              selectW.Email
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('click.ownAddress')"
              >{{ selectW.ProvinceName }}-{{ selectW.CityName }}</a-descriptions-item
            >
            <a-descriptions-item :label="$t('click.spareTitle')">{{
              selectW.Name
            }}</a-descriptions-item>
            <a-descriptions-item :label="$t('click.Owncontent')">{{
              selectW.Content
            }}</a-descriptions-item>
          </a-descriptions>
        </a-card>

        <a-card
          style="margin-bottom: 20px"
          :bordered="false"
          :loading="stepLoading"
          :title="$t('click.status')"
        >
          <a-steps
            v-model:current="currentStep"
            :items="[
              {
                title: t('click.status3'),
                description: t('click.des1'),
                disabled: true,
              },
              {
                title: t('click.status1'),
                description: handleDes,
                disabled: true,
              },
              {
                title: t('click.status2'),
                description: t('click.des3'),
                disabled: true,
              },
            ]"
          ></a-steps>
        </a-card>

        <!-- <a-card :bordered="false" :loading="workerLoading" :title="$t('click.worker')">
          <a-card-meta :title="vheader" description="工号:011450">
            <template #avatar>
              <a-avatar style="background-color: #87d068" :size="55">叶</a-avatar>
            </template>
          </a-card-meta>
          <template #actions>
            <div @click="evaluate">
              <edit-outlined key="evaluate" /> {{ $t("click.evaluate") }}
            </div>
          </template>
        </a-card> -->
      </a-drawer>
    </div>
  </div>
</template>

<script setup>
/**
 * CreationTime：2024.5.23 Thr
 * LastEditingTime：2024.5.27 Mon
 * Written by ShiYechen
 */
import { h, ref, computed, reactive } from "vue";
import { useRouter } from "vue-router";
import axios from "axios";
import { message } from "ant-design-vue";
import { useI18n } from "vue-i18n";
import { Modal } from "ant-design-vue";
import { EditOutlined } from "@ant-design/icons-vue";
import { TypographyParagraph } from "ant-design-vue";

const { t } = useI18n();

/**用户信息 */
const user = ref(JSON.parse(localStorage.getItem("user")));
/**弹窗状态 */
const open = ref(true);
/**弹窗表单数据 */
const formState = ref({
  OrderNumber: undefined,
  Phone: undefined,
  Email: undefined,
  Company: undefined,
  UserName: user.value.RealName,
  UserId: user.value.UserId,
  ProvinceName: undefined,
  Province: undefined,
  CityName: undefined,
  City: undefined,
  sparePart: undefined,
  sparePartId: undefined,
  Content: undefined,
});
const Threshold = ref(undefined); //备件库存
const inventory = ref(undefined); //备件库存输入
/**下拉列表 */
const options = ref([]);
const formRef = ref();
/**表单提交加载 */
const loading = ref(false);
const disabledVal = ref(computed(() => {
	const disValue = !(
		Object.entries(formState.value).every(([key, value]) => 
			value !== "" && value !== null && value !== undefined &&
			(key !== 'Content' || value?.trim() !== "")
		)
	);
	return disValue;
}));

/**省份列表 */
const provinceList = ref([]);
/**城市列表 */
const cityList = ref([]);
/**城市列表禁用 */
const cityDis = ref(true);
/**备件列表 */
const spareList = ref([]);

/**搜索条内容 */
let searchFormState = reactive({});
/**搜索条DOM */
const searchFormRef = ref();
const groupValue = ref("a")
const targetValue = ref(null);//状态
/**表格DOM */
const table = ref(null);
/**表格加载状态 */
const tbLoading = ref(false);
/**表格展示数据 */
const dataSource = ref([]);
const toolConfig = { refresh: true, height: true, columnSetting: false, striped: false };
/**表头数据 */
const columns = [
  {
    title: t("click.eventNum"),
    dataIndex: "EventNum",
  },
  {
    title: t("click.ownOrder"),
    dataIndex: "OrderNumber",
  },
  {
    title: t("click.company"),
    dataIndex: "Company",
  },
  {
    title: t("click.ownUser"),
    dataIndex: "UserName",
  },
  {
    title: t("click.createTime"),
    dataIndex: "CreateTime",
  },
  {
    title: t("click.status"),
    dataIndex: "eventStatus",
  },
  {
    title: t("click.action"),
    dataIndex: "action",
    align: "center",
  },
];
/**分页 */
const pagination = ref({
  total: 0,
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
});

/**表单打开状态 */
const Fopen = ref(false);
/**表单加载状态 */
const infoLoading = ref(false);
/**表单中展示的工单 */
const selectW = ref({});
/**表单进度条加载状态 */
const stepLoading = ref(false);
/**进度条当前进度 0,1,2 */
const currentStep = ref(0);
/**进度条处理中的描述 */
const handleDes = ref(t("click.des2"));
/**服务工程师加载状态 */
const workerLoading = ref(false);
/**服务工程师名称 */
const vheader = h("div", { class: "workerHead" }, [
  h("span", "叶辰"),
  /*   h("span", { class: "workerInfo" }, "服务工程师"), */
]);

const router = useRouter();

const timeList = [
  { key: "T", name: "今天" },
  { key: "Y", name: "昨天" },
  { key: "montimeo7", name: "近7天" },
  { key: "montimeo30", name: "近30天" },
  { key: "Year", name: "当年" },
  { key: "", name: "全部" },
];
const timeValue = ref("");

//点击快速查看
function selectTime() {
  console.log("点击快速查看：", timeValue.value);
  //加载报修订单
  loadData();
}

/**
 * 主函数入口
 */
init();

async function init() {
  await getDevice()
    .then((data) => {
      if (Array.isArray(data)) {
        data.map((item, index) => {
          options.value[index] = {
            value: item.equipmentid,
            label: item.ordernumber,
          };
        });
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });

  await getArea("2", "44")
    .then((data) => {
      if (Array.isArray(data)) {
        data.map((item, index) => {
          provinceList.value[index] = {
            value: item.countryid,
            label: item.countryname,
          };
        });
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });

  await loadData();

  //获取备件
  await getSparePart().then((data) => {
    console.log("备件列表继续返参：", data);
    if (Array.isArray(data)) {
      data.map((item, index) => {
        spareList.value[index] = {
          value: item.Id,
          label: item.Name,
        };
      });
    }
  });
}
//点击状态
const groupChange = (item) => {
	console.log(item.target.value);
	targetValue.value = item.target.value == "a" ? null : item.target.value == "b" ? 0 : item.target.value == "c" ? 1 : null;
	console.log("状态信息：",targetValue.value);
	loadData();
}
//获取备件
function getSparePart() {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Component/GetList", {})
      .then((response) => {
        console.log("备件列表返参：", response.data);
        if (response.data.code == 200 && response.data.ReturnType == true) {
          resolve(response.data.ReturnData);
        } else {
          reject(response.data.info);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**提交工单 */
function handleOk() {
  loading.value = true;
  let params = JSON.parse(JSON.stringify(formState.value));
  params.Province = params.Province.toString();
  params.City = params.City.toString();
  params.UserName = user.value.RealName;
  params.UserId = user.value.UserId;
  params.ComponentId = params.sparePartId; // 备件id
  formRef.value
    .validate()
    .then(() => {
      console.log("带备件信息的参数：", params);
      axios
        .post("api/CSSAPI/SaveWorkOrder", params)
        .then(function (response) {
          console.log("提交工单返回参数：", response.data);
          loading.value = false;
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            Modal.info({
              title: t("click.success"),
              content: h("div", {}, [
                h(
                  TypographyParagraph,
                  { copyable: { text: response.data.ReturnData.data } },
                  t("click.successin") + response.data.ReturnData.data
                ),
              ]),
              onOk() {
                Modal.destroyAll();
                handleCancel();
                if (response.data.ReturnCount == 2 || response.data.ReturnCount == 0) {
                  console.log("该备货了");
                  Modal.info({
                    title: "Warning",
                    content: h("div", {}, [h(TypographyParagraph, response.data.info)]),
                    onOk() {
                      Modal.destroyAll();
                      router.push({
                        path: "/stock",
                      });
                    },
                  });
                }
              },
            });

            formState.value = {
              OrderNumber: undefined,
              Phone: undefined,
              Email: undefined,
              Company: undefined,
              UserName: user.value.RealName,
              UserId: user.value.UserId,
              ProvinceName: undefined,
              Province: undefined,
              CityName: undefined,
              City: undefined,
              sparePart: undefined,
              sparePartId: undefined,
              Content: undefined,
            };
          }
        })
        .catch(function (error) {
          message.error(error.toString());
        });
    })
    .catch((error) => {
      loading.value = false;
      message.error(t("click.suberr"));
    })
    .finally(() => {
      console.log("表单提交完成");
      console.log("备件库存：", Threshold.value);
      console.log("备件库存输入：", inventory.value);
      if (Threshold.value === null) {
        //未设置备件库存
        console.log("未设置备件库存", Threshold.value);
        if (inventory.value === undefined) {
          console.log("未输入库存：", inventory.value);
        } else {
          console.log("输入了库存：", inventory.value);
          let param = {
            Id: params.ComponentId,
            UserId: user.value.UserId,
            Threshold: inventory.value,
          };
          saveThreshold(param)
            .then((res) => {
              console.log("设置备件库存成功：", res);
              Threshold.value = ref(undefined); //备件库存清空
              inventory.value = ref(undefined); //备件库存输入清空
            })
            .catch((error) => {
              console.log("设置备件库存失败：", error);
              Threshold.value = ref(undefined); //备件库存清空
              inventory.value = ref(undefined); //备件库存输入清空
            });
        }
      } else {
        console.log("已设置备件库存", Threshold.value);
      }
    });
}

//保存备件库存
function saveThreshold(params) {
  console.log("保存备件库存传参：", params);
  return new Promise((resolve, reject) => {
    axios
      .post("api/ComponentUserNumber/Save", params)
      .then((response) => {
        if (response.data.code == 200 && response.data.ReturnType == true) {
          resolve(response.data.ReturnData);
        } else {
          reject(response.data.info);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**打开表单 */
async function openForm(record) {
  console.log("打开表单：", record);
  Fopen.value = true;
  selectW.value = record;

  await getEvent(selectW.value.EventNum)
    .then((re) => {
		const res = re.data || [];
		console.log("状态返回参数：",res);
      if (res.length >= 1) {
        let event = res;
		console.log("打开表单Event:",event[0].eventStatus)
        currentStep.value = event[0].eventStatus == "处理中" ? 1 : event[0].eventStatus == "已完成" ? 2 : 0;
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**搜索数据 */
function loadData() {
  tbLoading.value = true;
  let newStr = searchFormState.searchKey;
  if (searchFormState.searchKey) {
    newStr = searchFormState.searchKey.replace(/\s+/g, "");
    pagination.value.current = 1;
  }
  axios
    .post(
      "api/CSSAPI/QueryWorkOrders",
      {
        EventNum: newStr, //事件编号
        UserId: user.value.UserId, //用户id
        DateType: timeValue.value, //日期
		Status:targetValue.value,//是否完成
        PrevPageNums: (pagination.value.current - 1) * pagination.value.pageSize,
        TopNums: pagination.value.pageSize,
      },
      {
        headers: {
          Token: user.value.Token,
        },
      }
    )
    .then((response) => {
      console.log("数据参数返回：", response.data);
      dataSource.value = response.data.ReturnData;
      pagination.value.total = response.data.ReturnCount;
      let eId = "";
      response.data.ReturnData.forEach((element, index) => {
        if (index == 0) {
          eId += element.EventNum;
        } else {
          eId += "," + element.EventNum;
        }
      });

      axios
        .post("api/CSSAPI/GetEventStatus", {
          EventNum: eId,
        })
        .then(function (response) {
          if (response.data.code != 200) {
            message.error(response.data.info);
          } else {
            let res = response.data.ReturnData.data;
            if (Array.isArray(res)) {
              dataSource.value.forEach((element) => {
                res.forEach((event) => {
                  if (element.EventNum == event.eventNum) {
                    element.eventStatus = event.eventStatus;
                  }
                });
              });
            }
          }
        })
        .catch(function (error) {
          message.error(error.toString());
        });
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      tbLoading.value = false;
    });
}

/**获取当前工单状态 */
function getEvent(eId) {
  stepLoading.value = true;
  return new Promise((resolve, reject) => {
    axios
      .post("api/CSSAPI/GetEventStatus", {
        EventNum: eId,
      })
      .then(function (response) {
        stepLoading.value = false;
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**用于初始弹窗获取设备 */
function getDevice() {
  return new Promise((resolve, reject) => {
    axios
      .post("api/Machine/GetMyMachine", {
        UserId: user.value.UserId,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**打开弹窗 */
function openModal() {
	formState.value = {
		OrderNumber: undefined,
		Phone: undefined,
		Email: undefined,
		Company: undefined,
		UserName: user.value.RealName,
		UserId: user.value.UserId,
		ProvinceName: undefined,
		Province: undefined,
		CityName: undefined,
		City: undefined,
		sparePart: undefined,
		sparePartId: undefined,
		Content: undefined,
	}
	open.value = true;
}
//点击备件库存
function openStock(id) {
  router.push({
    path: "/stock",
    query: {
      Id: id,
    },
  });
}

/**获取城市 */
function getArea(type, fid) {
  type = type.toString();
  fid = fid.toString();

  return new Promise((resolve, reject) => {
    axios
      .post("api/User/GetAreaData", {
        seltype: type,
        fid: fid,
      })
      .then(function (response) {
        if (response.data.code != 200) {
          reject(response.data.info);
        } else {
          resolve(response.data.ReturnData);
        }
      })
      .catch(function (error) {
        reject(error);
      });
  });
}

/**切换省份 */
async function provinceChange(value, option) {
  await getArea("3", formState.value.Province)
    .then((data) => {
      formState.value.City = null;
      formState.value.CityName = null;
      formState.value.ProvinceName = option.label.toString();
      formState.value.Province = formState.value.Province;
      cityDis.value = false;

      if (data.length >= 1) {
        data.map((item, index) => {
          cityList.value[index] = {
            value: item.countryid,
            label: item.countryname,
          };
        });
      }
    })
    .catch((error) => {
      message.error(error.toString());
    });
}

/**切换备件 */
async function spareChange(value, option) {
  formState.value.sparePart = option.label || "";
  formState.value.sparePartId = option.value || "";
  console.log("备件选择：", value, option);
  await getSpareNum(option.value).then((data) => {
    console.log("阈值返参：", data);
    if (Array.isArray(data)) {
      data.forEach((item) => {
        if (item.Id == option.value) {
          Threshold.value = item.Threshold;
          console.log("当前备件阈值：", item.Threshold);
        }
      });
    }
  });
  // formState.value.sparePart = option.value.toString();
}

//获取备件阈值
function getSpareNum() {
  let params = {
    UserId: user.value.UserId,
  };
  return new Promise((resolve, reject) => {
    axios
      .post("api/ComponentUserNumber/GetList", params)
      .then((response) => {
        if (response.data.code == 200 && response.data.ReturnType == true) {
          resolve(response.data.ReturnData);
        } else {
          reject(response.data.info);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

/**切换城市 */
function cityChange(value, option) {
  formState.value.CityName = option.label.toString();
  formState.value.City = formState.value.City;
}

/**选择器选择设备 */
function handleChange(e, opt) {
  formState.value.OrderNumber = opt.label.toString();
}

/**服务评价 */
function evaluate() {
  message.info("敬请期待~");
}

/**弹窗下拉框搜索 */
function filterOption(input, option) {
  return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

/**重置搜索,searchFormRef是搜索框DOM */
const reset = () => {
  searchFormRef.value.resetFields();
  loadData();
};

/**分页方法 */
function handleTableChange(e) {
  pagination.value = e;
  loadData();
}

/**保存草稿回调函数 */
function handleCancel() {
  loadData();
  open.value = false;
}

/**关闭弹窗回调函数 */
function handleClose() {
  formState.value = {};
  loadData();
  open.value = false;
}

/**关闭表单回调函数 */
function onFormClose() {
  selectW.value = {};
  Fopen.value = false;
}

/**返回上一页 */
function back() {
  history.back();
}

/**表单校验 */
function checkPhone(_, value) {
  const phoneVer = /[\d]/;
  if (!value) {
    return Promise.reject(new Error(t("click.phonein")));
  }
  if (value.match(phoneVer)) {
    return Promise.resolve();
  } else {
    return Promise.reject(new Error(t("click.phoneerr")));
  }
}

function checkEmail(_, value) {
  const emailVer = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (!value) {
    return Promise.reject(new Error(t("click.emailin")));
  }
  if (value.match(emailVer)) {
    return Promise.resolve();
  } else {
    return Promise.reject(new Error(t("click.emailerr")));
  }
}
</script>

<style scoped>
.header {
  height: 50px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e6e6e6;
  background: rgba(255, 255, 255, 0.24);
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
  z-index: 999;
  padding-left: 50px;
}

.back {
  height: 50px;
  line-height: 50px;
  color: #0099ff;
  margin-right: 80px;
  font-weight: bold;
  font-size: 20px;
  cursor: pointer;
}

.inner {
  margin-top: 50px;
}

a {
  color: #1890ff;
}

.workerHead {
  display: flex;
  align-items: center;
}

:deep(.workerInfo) {
  background-color: rgb(135, 208, 104);
  margin-left: 10px;
  font-weight: normal;
  font-style: italic;
}

.cardImp {
  margin-right: 10px;
}

.ant-form-item {
  margin-bottom: 0 !important;
}

.primaryAdd {
  margin-right: 10px;
}

.snowy-buttom-left {
  margin-left: 8px;
}
</style>
